var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 0C94.06 0 61.48 13.494 37.5 37.49C13.4953 61.4955 0.0066494 94.0516 0 128C0 161.934 13.5 194.514 37.5 218.51C61.48 242.506 94.06 256 128 256C161.94 256 194.52 242.506 218.5 218.51C242.5 194.514 256 161.934 256 128C256 94.066 242.5 61.486 218.5 37.49C194.52 13.494 161.94 0 128 0Z",
    fill: "url(#paint0_linear_34_29)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94 126.648C95.26 110.392 120.14 99.674 132.58 94.496C168.14 79.71 175.52 77.142 180.34 77.055C181.4 77.038 183.76 77.3 185.3 78.545C186.58 79.595 186.94 81.015 187.12 82.012C187.28 83.008 187.5 85.278 187.32 87.05C185.4 107.29 177.06 156.406 172.82 179.076C171.04 188.668 167.5 191.884 164.08 192.198C156.64 192.882 151 187.286 143.8 182.568C132.54 175.182 126.18 170.586 115.24 163.38C102.6 155.052 110.8 150.474 118 142.994C119.88 141.036 152.64 111.246 153.26 108.544C153.34 108.206 153.42 106.946 152.66 106.282C151.92 105.616 150.82 105.844 150.02 106.024C148.88 106.28 130.9 118.176 96.02 141.71C90.92 145.218 86.3 146.928 82.14 146.838C77.58 146.74 68.78 144.254 62.24 142.13C54.24 139.524 47.86 138.146 48.42 133.72C48.7 131.416 51.88 129.058 57.94 126.648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_29",
    x1: 12800,
    y1: 0,
    x2: 12800,
    y2: 25600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.871d8979187555599bafd35343bf243f.svg";
export { ForwardRef as ReactComponent };